import styled from '@emotion/styled';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import cursor from './cursor.svg?no-inline';


export const UpliftCalendarStylesWrapper = styled.div`
display: flex;
height: 100%;
font-size: 14px;
position: relative;

.fc-toolbar-chunk:nth-child(1) .fc-today-button {
  margin-left: 0
}

.fc-scrollgrid-section-liquid > td {
  border-bottom: none;
}

.fc-theme-standard .fc-scrollgrid {
  border-left: 0;
}
.fc-theme-standard .fc-scrollgrid {
  border-top: none;
}

.fc-timegrid-body,
.fc-timegrid-slots > table,
.fc-timegrid-cols > table,
.fc-col-header {
  /* make calendar content flexible width in animation */
  width: 100% !important;
}

/* Header section */
.fc .fc-scrollgrid-section table.fc-col-header th {
  border-top: none;
}

/* .fc .fc-scrollgrid-section table.fc-col-header th:first-child {
  border-bottom: none;
} */

.fc .fc-scrollgrid-section {

}

.fc-timeGridDay-view thead {
  display: none;
}

td.fc-timegrid-col.fc-timegrid-axis {
  border-top: none;
}

.fc .fc-timegrid-axis-frame {
  align-items: center;
  height: 44px;
  font-weight: 400;
  color: #A1A1A1;
  justify-content: center;
  font-size: 14px;
  user-select: none;
}

.fc .fc-col-header-cell-cushion {
  background: #fff;
  font-size: 12px;
  line-height: 15px;
  text-transform: uppercase;
  color: #333333;
  font-weight: 400;

  height: 100%;
}

/* Buttons */

.fc .fc-button-primary {
  background: none;
  box-sizing: border-box;
  border-radius: 0px;
  font-weight: 450;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.08em;
  color: #333333;
  text-transform: uppercase;
  height: 36px;
  border: 0;
  box-shadow: 0 0 0 1px #c4c4c4 inset;
  background-color: white;
  padding: 0 12px;
  outline: none;
}

.fc .fc-button-primary:not(:disabled):active:focus {
  box-shadow: 0 0 0 1px #aaa inset;
}

.fc .fc-button-primary,
.fc .fc-button-primary:hover,
.fc .fc-button-primary:focus,
.fc .fc-button-primary:active {
  background-color: white;
  color: #333333;
  outline: none;
}

.fc .fc-button-primary:disabled {
  background: none;
  color: #333333;
  border: 0;
}

.fc .fc-today-button {
  padding-top: 2px;
}

.fc .fc-prev-button,
.fc .fc-prev-button:hover,
.fc .fc-prev-button:focus,
.fc .fc-prev-button:active,
.fc .fc-next-button,
.fc .fc-next-button:hover,
.fc .fc-next-button:focus,
.fc .fc-next-button:active {
  box-shadow: none !important;
  width: 28px;
  padding: 0;
}

.fc .fc-prev-button:hover,
.fc .fc-prev-button:active,
.fc .fc-next-button:hover,
.fc .fc-next-button:active {
  background-color: #f6f6f6;
}


.fc .fc-icsConflicts-button,
.fc .fc-icsConflicts-button:hover,
.fc .fc-icsConflicts-button:active,
.fc .fc-icsConflicts-button:focus {
  box-shadow: none !important;
  outline: none;

  background-color: #FCF2EB;
  border: 1px solid #F1BD9D;
}

.fc .fc-settings-button,
.fc .fc-settings-button:hover,
.fc .fc-settings-button:active,
.fc .fc-settings-button:focus {
  box-shadow: none !important;
  cursor: default;
  outline: none;
  padding-right: 0;
}

/* End Buttons */

/* Toolbar */

.fc-toolbar {
  padding-right: 24px;
}

.fc-toolbar-chunk:nth-child(1) {
  display: flex;
  align-items: center;
}

.fc-toolbar-chunk:nth-child(1) .fc-toolbar-title {
  padding-top: 4px;
}

.fc-toolbar-title-month {
  font-weight: 600;
}

.fc-toolbar-title-year {
  font-weight: 400;
}

.fc .fc-toolbar.fc-header-toolbar {
  display: flex;
  align-items: flex-end;
}

.fc .fc-timegrid-slot {
  height: 30px;
}

/* End Toolbar */

.fc .fc-timegrid-slot-label-cushion {
  position: absolute;
  padding-left: 0;
  top: -9px;
  left: 0;
  background: #fff;
  font-size: 14px;
  color: #A1A1A1;
  font-weight: 400;
  text-transform: uppercase;
}

tr:first-child>.fc-timegrid-slot.fc-timegrid-slot-label.fc-scrollgrid-shrink {
  display: none;
}

.fc-timegrid-slot.fc-timegrid-slot-label.fc-scrollgrid-shrink {
  position: relative;
}

.fc .fc-timegrid-slot-minor {
  border-top-style: hidden;
}

.fc-dayGridMonth-view td {
  border-style: dotted;
}

.fc .fc-bg-event {
  background: transparent;
  opacity: 1;
  padding-left: 0px;
  padding-right: 2px;
  padding-top: 0px;
  padding-bottom: 2px;
}

.fc .fc-h-event {
  border: none;
  background-color: transparent;
  padding: 0px 1px;
  margin: 0px;
}

.fc .fc-daygrid-body-natural .fc-daygrid-day-events {
  margin-bottom: 0;
}

.fc .day-cell__today {
  background-color: transparent;
}

.fc-scrollgrid-section.fc-scrollgrid-section-body:first-child,
.fc-scrollgrid-section.fc-scrollgrid-section-body:first-child {
  box-shadow: 0px 3px 4px -4px #555;
  position: relative;
  z-index: 3;
}

.fc-timegrid-axis-frame.fc-scrollgrid-shrink-frame.fc-timegrid-axis-frame-liquid {
  height: 100%;
}

.fc-daygrid-body .fc-daygrid-body-unbalanced .fc-daygrid-body-natural {
  overflow: hidden;
}

.fc-timegrid-divider {
  display: none;
}

.fc-timegrid-event {
  margin-bottom: 0.5px;
}

.fc-timegrid-event .fc-event-main {
  padding: 0.5px 0.5px 0 0;
}

.fc-v-event {
  background: transparent;
  border: none;
  box-shadow: none;
}

.fc-direction-ltr .fc-timegrid-col-events {
  margin: 0;
}

.fc-timegrid.fc-timeGridWeek-view.fc-view .fc-col-header-cell-cushion {
  font-weight: 600;
  padding: 0px;
  font-weight: 400;

  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}

.fc-col-header-cell-cushion-weekday {
  color: #777;
  line-height: 1;
  font-size: 16px;
  font-weight: 400;
  padding-top: 3px;
}

.fc-day-today .fc-col-header-cell-cushion-weekday {
  color: #000000de;
}

.fc-col-header-cell-cushion-date {
  color: #777;
  background: #fff;
  border-radius: 50%;
  margin-top: 0px;
  height: 36px;
  width: 36px;
  text-align: center;
  padding-top: 0px;
  font-size: 16px;
  display: inline;
  line-height: 38px;
  font-weight: 400;
}

.fc-col-header-cell-cushion-date.additional-space-left {
  padding-left: 2px;
}

.fc-col-header-cell-cushion-date.additional-space-right {
  padding-right: 2px;
}

.fc-day-today .fc-col-header-cell-cushion-date {
  background: #643c9d;
  color: #fff;
  font-weight: 500;
}

.fc .fc-timegrid-col.fc-day-today {
  background: none;
}

.fc .fc-timegrid-now-indicator-line {
  border-width: 2px 0 0;
  position: relative;
}

.fc .fc-timegrid-now-indicator-line:before {
  position: absolute;
  width: 12px;
  height: 12px;
  content: ' ';
  background-color: red;
  border-radius: 50%;
  left: -6px;
  top: -7px;
}

.fc .fc-timegrid-now-indicator-arrow {
  display: none;
}

.fc .fc-timegrid-now-indicator-container {
  overflow: visible;
}

/* Body */
.fc-scrollgrid.fc-scrollgrid-liquid > thead {
  position: relative;
  z-index: 2;
}

.fc-scrollgrid.fc-scrollgrid-liquid > thead .fc-col-header-cell {
  position: relative;
}

.fc-scrollgrid.fc-scrollgrid-liquid > thead .fc-col-header-cell:before {
  content: ' ';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
}
/* End Body */

/* Cursor styles */
.fc-timegrid-bg-harness {
  pointer-events: none;
}

body & .fc .fc-timegrid-cols {
  cursor: url(${cursor}) 8 8, crosshair;
  z-index: 2;
}

body.fc-not-allowed & .fc .fc-timegrid-cols {
  cursor: not-allowed !important;
}

body & .fc .fc-day-past {
  cursor: not-allowed;
}

/* End Not allowed state */
`;
